module.exports = __webpack_public_path__ + "img/z32.ff5f94ce.png";